import React, { FunctionComponent, CSSProperties } from "react";

interface SpanButtonProps {
  className: string;
  onClick: () => void;
  content: string;
  style?: CSSProperties;
}

export const SpanButton: FunctionComponent<SpanButtonProps> = props => {
  return (
    <span
      style={props.style}
      onClick={props.onClick}
      className={props.className}
    >
      {props.content}
    </span>
  );
};
